import { QueryClient, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateWatchlistItem, WatchlistItem } from '@thro-types/users';

import { AxiosRequestConfig } from 'axios';

import { createWatchlistItem, deleteWatchlistItem, getWatchlist } from '../usersService';

const invalidateWatchlist = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({
    predicate: query => {
      return query.queryKey.includes('watchlist');
    }
  });
};

export const useWatchlistListQuery = (config?: AxiosRequestConfig) => {
  const queryKey = ['watchlist', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getWatchlist(config);
    }
  });
};

export const useWatchlistMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();
  const update = useMutation<WatchlistItem, Error, CreateWatchlistItem>({
    mutationFn: args => {
      return createWatchlistItem(args, config);
    },
    onSuccess: data => {
      invalidateWatchlist(queryClient);
    }
  });

  const deletion = useMutation<WatchlistItem, Error, number>({
    mutationFn: args => {
      return deleteWatchlistItem(args, config);
    },
    onSuccess: data => {
      invalidateWatchlist(queryClient);
    }
  });

  return { update, deletion } as const;
};
